import React from "react";
import styles from "./time-series-line-graph-wrapper.module.scss";
import ReactEChart from "echarts-for-react";
import Spinner from "@components/atoms/spinner/spinner";
import { TimeSeriesLineNoData } from "@components/molecules/time-series-line-no-data/time-series-line-no-data";

interface TimeSeriesLineGraphWrapperPropTypes {
  labelText: string;
  graphOptionsObject: any | undefined | null;
}

const cssClassName = "time-series-line-graph-wrapper";

export const TimeSeriesLineGraphWrapper = ({
  labelText,
  graphOptionsObject,
}: TimeSeriesLineGraphWrapperPropTypes) => {
  const Echart = () => {
    return (
      <div className={styles[`${cssClassName}__graph-wrapper`]}>
        <ReactEChart
          style={{
            width: "100%",
            height: "100%",
          }}
          option={graphOptionsObject}
        />
      </div>
    );
  };

  const MySpinner = () => {
    return (
      <div className={styles[`${cssClassName}__spinner-wrapper`]}>
        <Spinner />
      </div>
    );
  };

  const getContent = (options: any | undefined | null): JSX.Element => {
    const contentMap: { [key: string]: JSX.Element } = {
      undefined: <MySpinner />,
      null: <TimeSeriesLineNoData />,
      default: <Echart />,
    };

    return contentMap[
      options === undefined
        ? "undefined"
        : options === null
        ? "null"
        : "default"
    ];
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__extra-margin-bottom`]}>
        <div className={styles[`${cssClassName}__attribute-name`]}>
          {labelText}
        </div>
      </div>
      <div className={styles[`${cssClassName}__graph-spinner-container`]}>
        {getContent(graphOptionsObject)}
      </div>
    </div>
  );
};
